export enum ContractType {
  UPFRONT = 'Upfront',
  ONE_TIME_FINANCED = 'OneTimeFinanced',
}
